import { IData } from './IData';
import { DataMapper } from './mapper';

/**
 * checking the result property response and create a model with help of mapper class
 * @param   {array} data search api response
 */
export class DataModel {
  data: Array<IData> = [];

  constructor(data: any = []) {
    if (data) {
      const transModel = new DataMapper(data);
      this.data.push(transModel.dataItem);
    }
  }
}
